import { createSelector } from "@reduxjs/toolkit";

const getOsservatorioStore = (state) => state.osservatorio;

export const getProfilo = createSelector(getOsservatorioStore, (osservatorio) => osservatorio.profilo);

export const inserimentoProfiloEnded = createSelector(getOsservatorioStore, (osservatorio) => osservatorio.inserimentoCompletato);

export const getIstitutiScolastici = createSelector(getOsservatorioStore, (osservatorio) => osservatorio.istituti.data);

export const fetchIstitutiScolasticiEnded = createSelector(getOsservatorioStore, (osservatorio) => osservatorio.istituti.fetchEnded);

export const getIncarichi = createSelector(getOsservatorioStore, (osservatorio) => osservatorio.incarichi.data);

export const fetchIncarichiEnded = createSelector(getOsservatorioStore, (osservatorio) => osservatorio.incarichi.fetchEnded);
